module.exports = __webpack_public_path__ + "img/logo.48b8ebf2.png";